import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function JoinRedirect() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    if (token) {
      navigate(`/feed?join_token=${token}`);
    } else {
      navigate('/feed');
    }
  }, [searchParams, navigate]);

  return null;
}
